<template>
  <div class="NewTonnage">
    <div class="content">
      <sp-tag-group v-model="type" class="tags">
        <sp-tag label="ShipNameEssentials">{{ $l('ShipNameEssentialsTagLabel') }}</sp-tag>
        <sp-tag label="ShipTypeHoldType">{{ $l('ShipTypeHoldTypeTagLabel') }}</sp-tag>
        <sp-tag label="ShipsCargoGearsCapacity">{{ $l('ShipsCargoGearsCapacityTagLabel') }}</sp-tag>
        <sp-tag label="PNIClass">{{ $l('PNIClassTagLabel') }}</sp-tag>
        <sp-tag label="RegisteredOwnership">{{ $l('RegisteredOwnershipTagLabel') }}</sp-tag>
        <sp-tag label="CharactoristicCertificatesorApproval">{{ $l('CharactoristicCertificatesorApprovalTagLabel') }}</sp-tag>
        <sp-tag label="SpeedConsumption">{{ $l('SpeedConsumptionTagLabel') }}</sp-tag>
      </sp-tag-group>
      <SpForm :default-value="shipInfo" @submit="submit">
        <ShipNameEssentials v-show="type=='ShipNameEssentials'" v-model="shipInfo" class="pageComponent" />
        <ShipTypeHoldType v-show="type=='ShipTypeHoldType'" v-model="shipInfo" class="pageComponent" />
        <ShipsCargoGearsCapacity v-show="type=='ShipsCargoGearsCapacity'" v-model="shipInfo" class="pageComponent" />
        <PNIClass v-show="type=='PNIClass'" v-model="shipInfo" class="pageComponent" />
        <RegisteredOwnership v-show="type=='RegisteredOwnership'" v-model="shipInfo" class="pageComponent" />
        <CharactoristicCertificatesorApproval v-show="type=='CharactoristicCertificatesorApproval'" v-model="shipInfo" class="pageComponent" />
        <SpeedConsumption v-show="type=='SpeedConsumption'" v-model="shipInfo" class="pageComponent" />
        <sp-button class="mg-t-80" type="back" :bold="-1" :width="333" :height="101">
          <label class="font-bold font18">{{ $L('back') }}</label>
        </sp-button>
        <div class="flex-center mg-b-80 mg-t-80">
          <div class="txt-left">
            <p class="reminder2">{{ $l('submitReminder') }}</p>
            <sp-button type="primary" html-type="submit" :bold="-1" :width="984" :height="101">
              <label class="font-bold font18">{{ $L('submit') }}</label>
            </sp-button>
          </div>
        </div>
      </SpForm>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import spButton from '@/components/common/SpButton'
import spTag from '@/components/common/SpTag'
import spTagGroup from '@/components/common/SpTagGroup'
import ShipNameEssentials from '@/components/shipOwner/tonnages/newTonnage/ShipNameEssentials'
import ShipTypeHoldType from '@/components/shipOwner/tonnages/newTonnage/ShipTypeHoldType'
import ShipsCargoGearsCapacity from '@/components/shipOwner/tonnages/newTonnage/ShipsCargoGearsCapacity'
import PNIClass from '@/components/shipOwner/tonnages/newTonnage/PNIClass'
import RegisteredOwnership from '@/components/shipOwner/tonnages/newTonnage/RegisteredOwnership'
import CharactoristicCertificatesorApproval from '@/components/shipOwner/tonnages/newTonnage/CharactoristicCertificatesorApproval'
import SpeedConsumption from '@/components/shipOwner/tonnages/newTonnage/SpeedConsumption'
import SpForm from '@/components/common/SpForm'
import SpMessage from '@/components/common/SpMessage'
import { addShipApi, shipDetailApi } from '@/request/APIs/so'
export default {
  name: 'NewTonnage',

  nameSpace: 'shipOwner.tonnages.newTonnage',

  components: {
    SpForm,
    spButton,
    spTag,
    spTagGroup,
    ShipNameEssentials,
    ShipTypeHoldType,
    ShipsCargoGearsCapacity,
    PNIClass,
    RegisteredOwnership,
    CharactoristicCertificatesorApproval,
    SpeedConsumption
  },

  props: {
  },

  data () {
    return {
      type: 'ShipNameEssentials',
      shipInfo: {
        title: 'MV',
        particular: {
          content: ''
        },

        crane: {},
        derrick: {},
        certificates: {},
        gearType: '0', // 默认无船钓; 0 无船钓; 1 crane; 2 derrick; 3 crane & derrick
        oilConsumptions: {
          main: {
            laden: {},
            ballast: {}
          },

          auxiliaries: {
            sailing: {},
            parked: {}
          }
        }
      }
    }
  },

  computed: {
    routerQuery () {
      return this.$route.query
    }
  },

  watch: {

  },

  created () {
    this.getShipDetail(this.routerQuery.id)
  },

  mounted () {
  },

  methods: {
    submit (params) {
      if (params.validate) {
        const shipForm = JSON.parse(JSON.stringify(this.shipInfo))
        // 未被选择的证书不上传
        const certificates = {}
        Object.keys(shipForm.certificates).forEach(key => {
          if (shipForm.certificates[key]?.certificates) {
            certificates[key] = shipForm.certificates[key]
          }
        })
        shipForm.certificates = certificates

        //  船吊判断
        // 无船钓
        if (this.shipInfo.gearType === '0') {
          delete shipForm.crane
          delete shipForm.derrick
        } else {
          // 有船吊
          // Cranes 未选中
          if (!this.shipInfo.cranes) {
            delete shipForm.crane
          } else { // Cranes 选中
            // craneYesCombined 未选中
            shipForm.gearType = 1
            if (!this.shipInfo.craneYesCombined) {
              shipForm.crane.swlCombinedMin = null
              shipForm.crane.swlCombinedMax = null
            }
          }
          // Derricks 未选中
          if (!this.shipInfo.derricks) {
            delete shipForm.derrick
          } else { // Derricks 选中
            shipForm.gearType = 2
            // derricksYesCombined 未选中
            if (!this.shipInfo.derricksYesCombined) {
              shipForm.derrick.swlCombinedMin = null
              shipForm.derrick.swlCombinedMax = null
            }
          }

          // Cranes 选中 && Derricks 选中
          if (this.shipInfo.cranes && this.shipInfo.derricks) {
            shipForm.gearType = 3
          }
        }

        delete shipForm.additionalOilSpeedDesc
        addShipApi(shipForm).then(res => {
          if (res.code === 1) {
            SpMessage.success(res.message)
          }
        })
      } else {
        SpMessage({
          message: 'The format of the information entered is incorrect, verification failed, please check \'',
          type: 'error'
        })
      }
    },

    // 获取船详情
    getShipDetail (id) {
      if (!id) return
      shipDetailApi(id).then(res => {
        const info = res.data
        if (info.gearType === 1) {
          info.gearType = 1
          info.cranes = 1
        } else if (info.gearType === 2) {
          info.gearType = 1
          info.derricks = 2
        } else if (info.gearType === 3) {
          info.gearType = 1
          info.cranes = 1
          info.derricks = 2
        }

        if (!info?.crane) {
          info.crane = {}
        }
        if (!info?.derrick) {
          info.derrick = {}
        }
        this.shipInfo = info
      })
    }
  }
}
</script>

<style scoped lang="less">
.NewTonnage{
  >.content{
    padding:@gap @gap/2 @gap @gap;
    /deep/.pageComponent{
      margin-top: @gap;

        .item{
          margin:@gap/2 0 @gap/2 0;
          .SpSelectOption{
            .label{
              text-align: left;
            }
          }
          .label{
            text-align: right;
            font-size: 18px;
            font-weight: 400;
            font-family: Arial;
            box-sizing:border-box;
            padding:@gap/2;
          }
          .label-bold{
            text-align: right;
            font-size: 18px;
            font-family: Arial;
            font-weight: bold;
            color: #000000;
            font-style: italic;
            box-sizing:border-box;
            padding:@gap/2;
          }
          .unit{
            font-size: 18px;
            font-family: Arial;
            font-weight: 400;
            color: #000000;
            opacity: 0.6;
            box-sizing:border-box;
            padding-left: @gap/4;
          }
        }
    }
    /deep/.reminder,.reminder2{
      background: #F6F6F6;
      opacity: 0.6;
      text-align: left;
      text-indent: 2em;
    }
    .reminder2{
      text-indent: 0em;
    }
  }
}
</style>
